import React, { useContext } from 'react'

import Button from '../Common/Button'
import Paper from '@mui/material/Paper'
import ButtonPremuinBasket from '@/components/Subscription/ButtonPremuinBasket'
import Grid from '@mui/material/Grid'
import Dialog from '@/components/Common/Dialog'
import ProfileContext from '@/components/Context/ProfileContext'
import { useTheme } from '@mui/material'
import SETTINGS from '@/src/settings'
import Image from 'next/image'

type Props = {
  dialogVersion?: boolean
  openDialog?: boolean
  setOpenDialog?: (value) => void
}

export const listOffer = (profile, theme) => [
  {
    subscription: false,
    title: 'web_offer_free_subscription',
    colorTitle: '#000',
    price: 0,
    listFunction: [
      { text: `Frais de gestion ${SETTINGS.fraisPlateforme} €`, active: true },
      {
        text: `Pas de frais de livraison à partir de  ${profile?.globalFrancoMagic} € de commande`,
        active: true,
      },
      { text: "Tarifs standard sur la centrale d'achat ", active: true },
      { text: 'Pas de cagnottage', active: true },
    ],
    stylePaper: {
      borderColor: '#BBBBBB',
    },
  },
  {
    subscription: true,
    button: ButtonPremuinBasket,
    title: 'web_offer_premium_subscription',
    colorTitle: theme.palette.secondary.main,
    price: profile.price_subscription_value,
    priceGroupement: 'En partenariat avec mon groupement',
    listFunction: [
      { text: `Frais de gestion offert`, active: true },
      { text: `Pas de frais de livraison à partir de 1€ de commande`, active: true },
      { text: "Tarifs  préférentiels sur la centrale d'achat", active: true },
      { text: 'Cagnotte (0.5%)', active: true },
      { text: 'Connexion LGO', active: true },
    ],
    stylePaper: {
      borderColor: theme.palette.secondary.main,
      backgroundImage: 'url("/images/subscriptions/backgroupSubscription.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    },
  },
]

const OfferSubscription: React.FC<Props> = ({
  dialogVersion = false,
  openDialog,
  setOpenDialog,
}) => {
  const theme = useTheme()

  const { profile } = useContext(ProfileContext)

  // Abonnement masque pour les usergroups non eligibles (Aelia/Outre-Mer, cf. API eligibleSubscription).
  // On masque uniquement si explicitement false : les visiteurs non connectes voient toujours l'offre.
  if (profile?.eligibleSubscription === false) {
    return null
  }

  const ContentSubscription = (
    <Grid container spacing={2}>
      {listOffer(profile, theme).map((offer, index) => {
        const notSubscription = !!offer.subscription && !profile?.groupSubscriptionActive

        return (
          <Grid item xs={12} md={6} key={index}>
            <Paper className="p-4 border border-solid text-center min-h-[370px]" style={offer.stylePaper}>
              <div className="text-lg font-bold flex justify-between" style={{ color: offer.colorTitle }}>
                <div>{t({ id: offer.title })}</div>
                <div>
                  {notSubscription ? (
                    <Image
                      src={`/images/subscriptions/recommanded.png`}
                      height={30}
                      width={180}
                      alt={`check`}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="text-sm min-h-[110px]">
                <div className="text-left text-lg text-[#737373] mt-2 mb-4">
                  {!!offer.subscription && !!profile.groupPremiumGroupement ? (
                    <span className="text-[28px] font-bold text-black">{offer.priceGroupement}</span>
                  ) : (
                    <>
                      <span className="text-[28px] font-bold text-black">{offer.price}€ </span> / mois
                      {notSubscription ? (
                        <span style={{ fontSize: 10, marginLeft: 10 }}>
                          ({t({ id: 'web_abo_engagement' })})
                        </span>
                      ) : null}
                    </>
                  )}
                </div>
                <div className="my-4">
                  {notSubscription ? (
                    <ButtonPremuinBasket />
                  ) : (!!offer.subscription && !!profile?.groupSubscriptionActive) ||
                    (!offer.subscription && !profile?.groupSubscriptionActive) ? (
                    <Button fullWidth disabled={true} style={{ borderRadius: 0, color: '#6a6a6a' }}>
                      Offre actuelle
                    </Button>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div style={{ padding: 16 }}>
                {offer.listFunction.map((functionOffer, index) => {
                  return (
                    <div key={index} className={'flex flex-row items-center h-8'}>
                      <div style={{ marginRight: 8 }}>
                        <Image
                          src={
                            functionOffer.active
                              ? `/images/subscriptions/check.png`
                              : `/images/subscriptions/uncheck.svg`
                          }
                          width={20}
                          height={20}
                          alt={`check`}
                        />
                      </div>
                      <div style={{ textAlign: 'left' }}>{functionOffer.text}</div>
                    </div>
                  )
                })}
              </div>
            </Paper>
          </Grid>
        )
      })}
    </Grid>
  )

  return dialogVersion ? (
    <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
      {ContentSubscription}
    </Dialog>
  ) : (
    <>{ContentSubscription}</>
  )
}

export default OfferSubscription
